import { useState } from "react";
import { ASSET_PATHS } from "./assets";

export const IntroductionTabs = () => {
  const [activeTab, setActiveTab] = useState("INTRODUCTION");
  const tabs = ["INTRODUCTION", "GETTING STARTED"];

  const tabContent = {
    INTRODUCTION: {
      title: "AI-Powered CAPTCHA Solver",
      description: "Say goodbye to CAPTCHA interruptions. CaptchaSonic solves them instantly so you can browse and automate without friction.",
      image: ASSET_PATHS.introduction.intro,
    },
    "GETTING STARTED": {
      title: "Start in Seconds",
      description: "Plug in our API or use the extension. No setup headaches — just instant solving, right out of the box.",
      image: ASSET_PATHS.introduction.started,
    },
  };

  return (
    <section className="border-b border-gray-400/30 py-20 md:py-28 bg-gradient-to-b text-white from-[#000000] to-[#1e011b]">
      <div className="container mx-auto px-4">
        {/* --- Tab Navigation (Slightly larger with better hover) --- */}
        <nav className="mb-12 md:mb-16">
          <div className="flex flex-col sm:flex-row text-2xl sm:text-3xl md:text-4xl items-start sm:items-center justify-start font-pixel">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`relative mr-2 sm:mx-4 py-2 px-3 md:px-4 transition-colors duration-300 outline-none ${
                  activeTab === tab
                    ? "text-white"
                    : "text-gray-500 hover:text-white"
                }`}
              >
                {tab}
                <span
                  className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-green-400 to-white/70 rounded-full transition-transform duration-300 ease-in-out ${
                    activeTab === tab ? "scale-x-100" : "scale-x-0"
                  }`}
                  style={{ transformOrigin: 'center' }}
                />
              </button>
            ))}
          </div>
        </nav>

        {/* --- Animated Content Area (Larger with more space) --- */}
        <div key={activeTab} className="flex flex-col md:flex-row justify-center items-start mt-8 md:mt-12 gap-16 animate-fade-in">
          
          {/* --- BIGGER & BOLDER TEXT CONTENT --- */}
          <div className="w-full md:w-1/2 flex flex-col justify-center">
            {/* Gradient Title */}
            <h3 className="font-pixel text-4xl sm:text-5xl md:text-6xl pb-8 leading-tight bg-gradient-to-r from-green-500 to-white/70 bg-clip-text text-transparent">
              {tabContent[activeTab].title}
            </h3>
            <p className="font-kodeMono text-lg sm:text-xl md:text-2xl text-gray-300 leading-relaxed">
              {tabContent[activeTab].description}
            </p>
          </div>
          
          {/* --- LARGER & MORE INTERACTIVE IMAGE CONTAINER --- */}
          <div className="group w-full md:w-1/2 relative p-1 rounded-3xl bg-gradient-to-br from-green-400 via-green-500 to-white shadow-lg shadow-lime-500/20 transition-all duration-500 hover:shadow-2xl hover:shadow-lime-500/30">
            <div className="bg-black rounded-3xl p-3">
              <img
                src={tabContent[activeTab].image}
                alt={tabContent[activeTab].title}
                className="rounded-2xl w-full h-auto object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* CSS for the fade-in animation */}
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }
      `}</style>
    </section>
  );
};
